<template>
    <div class="table-layout">

        <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>

        <el-table class="mt5" :height="500+'px'" :data="bizEventMsgSubscrList" border style="width: 100%">
            <el-table-column prop="srcComName" label="订阅公司" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="topicName" label="业务主题" align="left" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizMsgName" label="事件名称" align="left" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="支持小程序" align="left" width="160">
                <template slot-scope="rows">{{miniAppAliases[rows.row.miniAppAlias]}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
        </el-table>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import bizMsgApi from '../../api/bizMsg'
    //
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "订阅公司",
                "code": "srcComName",
                "basic": true
            }
        ]
    };
    //
    export default {
        name: 'swb-biz-event-msg-subscr-list',
        props: ['staffId', 'eventMsgId'],
        desc: '业务事件消息订阅',
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                bizEventMsgSubscrList: [],
                srcCatType: {},
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                miniAppAliases: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //查询排序配置信息
            this.queryConfig = searchConfigData || {};
            this.miniAppAliases = {
                "retailerPurch": "零售商采购管理",
                "retailerAsset": "零售商资产管理",
                "retailerAssist": "零售商门店小助手"
            };
            // 获取已订阅消息
            this.getBizEventMsgSubscrList();
            //
            this.srcCatType = getEnumMap('srcCatType', 'value2text');
        },
        methods: {
            queryHandler(queryModel) {
                // 接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getBizEventMsgSubscrList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBizEventMsgSubscrList();
            },
            getBizEventMsgSubscrList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.staffId = this.staffId;
                filterItems.eventMsgId = this.eventMsgId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                bizMsgApi.getBizEventMsgSubscrPageList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.bizEventMsgSubscrList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 取消订阅
            cancleMsgSubscr: function (id) {
                let self = this;
                self.$confirm('确定取消该订阅吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    let postData = {};
                    postData.id = id;
                    bizMsgApi.deleteBizEventMsgById(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.getBizEventMsgSubscrList();
                            //
                            MsgBox.success('取消订阅成功！');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizMsg/SubscrList.vue